import { StudentFreeSignup } from 'shared/pages/Signup/StudentSignup/StudentFreeSignup/StudentFreeSignup';
import { TeacherFreeSignup } from 'shared/pages/Signup/TeacherSignup/TeacherFreeSignup/TeacherFreeSignup';
import { LoadingSpinner } from 'shared/components/loading/LoadingSpinner/LoadingSpinner';

import { useSignupPageSummaryFromUrl } from 'modules/signup-page/hooks/useSignupPageSummaryFromUrl';
import { useTenantInfo } from 'modules/tenant/hooks';

export const FreeSignup = () => {
    const {tenantInfo} = useTenantInfo();
    const signupPageSummary = useSignupPageSummaryFromUrl(tenantInfo.id);

    return (
        <> 
            {!signupPageSummary && <LoadingSpinner/>}
            {signupPageSummary && (
                signupPageSummary.is_teacher ? (
                    <TeacherFreeSignup signupPageSummary={signupPageSummary}/>
                ) : (
                    <StudentFreeSignup signupPageSummary={signupPageSummary}/>
                )
            )}
        </>
    );
};